import React from 'react'
import { Stack } from '~/components/_layouts'
import { ActionPlanCard } from '../cards/ActionPlanCard'
import { AylaCard } from '../cards/AylaCard'
import { AylaCardBig } from '../cards/AylaCardBig'
import { CoachSupportCard } from '../cards/CoachSupportCard'
import { RecommendedJobsCard } from '../cards/RecommendedJobsCard'
import { RecommendedBlogsCard } from '../cards/RecommendedBlogsCard'
import { RecommendedCard } from '../cards/RecommendedCard'
import { UkCoachCard } from '../cards/UkCoachCard'
import { UpcomingEventsCard } from '../cards/UpcomingEventsCard'

export function SoloPlus({ current_user }) {
  return (
    <Stack spacing={8}>
      <div className="grid gap-8 xl:grid-cols-[1fr_1fr] 2xl:grid-cols-[4fr_3fr_3fr]">
        <ActionPlanCard className="action-plan-card xl:col-span-2 2xl:col-span-1" />
        {current_user?.intoo_uk ? (
          <UkCoachCard />
        ) : (
          <AylaCard className="ayla-card" />
        )}
        {current_user?.has_upcoming_events ? (
          <UpcomingEventsCard />
        ) : (
          <CoachSupportCard
            className="coach-support-card"
            programLevel="solo_plus"
          />
        )}
      </div>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1fr]">
        <RecommendedJobsCard className="recommended-jobs" />
        {current_user?.intoo_uk ? (
          <AylaCardBig />
        ) : (
          <RecommendedBlogsCard className="recommended-blogs" />
        )}
      </div>
      <RecommendedCard />
    </Stack>
  )
}
